import userServices from '../../../services/user'
import orgServices from '../../../services/notisphere/organization'
import SitesModel from './SitesModel'
import { SITE_STATUS } from '../../../misc/commons'
import sitesService from '../../../services/provider/sites'
import { AG_GridCustomizedTableHeaders_Key, Provider_Sites_AgGrid } from '../../../misc/tableHeaders'
import _ from 'lodash'

export default {
    components: {
        SitesModel
    },
    data() {
        return {
            rowModelType: 'serverSide',
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
                paginationPageSize: 500,
            },
            total: 0,
            items: [],
            search: {
                organization_id: null,
                status: null,
                siteName: null,
                gln: null,
                userCount: null,
                add1: null,
            },
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            organization_id: null,
            organizations: [],
            gridApi: null,
            columnApi: null,
            site_status: SITE_STATUS,
            sitesModalKey: 0,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            globalSearchValue: ''
        }
    },
    beforeMount() {
        this.columnDefs = Provider_Sites_AgGrid
    },
    mounted() {
        if (this._isNotisphere) {
            this.fetchOrgMeta()
        }
    },
    computed: {
        header() {
            var arr = [
                {
                    label: 'Site Name',
                    name: 'siteName',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Site Address',
                    name: 'add1',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'GLN',
                    name: 'gln',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Number of Users',
                    name: 'userCount',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Status',
                    name: 'status',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'col-stt'
                },
                {
                    name: 'action',
                    row_text_alignment: 'text-right',
                    column_text_alignment: 'text-right',
                }
            ]

            if (this._isNotisphere) {
                return arr
            } else {
                return arr.filter(x => {
                    if (!['organization_name', 'organization_type'].includes(x.name)) {
                        return x
                    }
                })
            }
        },
    },
    methods: {
        saveState(params) {
            this.table_Connection_Data.Provider_Login.Sites_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Provider_Login?.Sites_Headers
            if (columnState) {
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            } else {
                const defaultColumnState = Provider_Sites_AgGrid.map((col) => ({
                    colId: col.field,
                    hide: col.hide || false,
                    pinned: null,
                    sort: null,
                    sortIndex: null,
                    width: col.minWidth || 100
                }))
                params.columnApi.applyColumnState({ state: defaultColumnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            this.table_Connection_Data.Provider_Login.Sites_Filters = event.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Provider_Login?.Sites_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            if (this.gridApi) {
                this.gridApi.refreshServerSideStore()
            }
        },
        addMoreClick() {
            this.sitesModalKey += 1
            this.$nextTick(() => {
                this.$refs.sitesModel.forceRerenderInsert()
            })
        },
        updateSite(payload, e = null) {
            this.sitesModalKey += 1
            this.$nextTick(() => {
                this.$refs.sitesModel.forceRerenderUpdate(payload.site_id)
            })
            if (e) {
                e.stopPropagation()
            }
        },
        view(item, e = null){
            this.sitesModalKey += 1
            this.$nextTick(()=>{
                this.$refs.sitesModel.forceRerenderView(item.site_id, item.siteName)
            })
            if (e) {
                e.stopPropagation()
            }
        },
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            that.search.status = params.request?.filterModel?.status?.values
            that.search.siteName = params.request?.filterModel?.siteName?.filter
            that.search.gln = params.request?.filterModel?.gln?.filter
            that.search.userCount = params.request?.filterModel?.userCount?.filter
            that.search.add1 = params.request?.filterModel?.siteAddress?.filter
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            that.search.filterModel = that.gridApi.getFilterModel()
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search,
                        organization_id: that.organization_id,
                        search: that.globalSearchValue,
                        email: email,
                    }
                    const resp = await sitesService.downloadAgGridSitesXLSX(query_param)
                    console.log(resp)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }
            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        fetchData(params) {
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const datasource = {
                getRows(params) {
                    // Set search parameters from filter model
                    that.search.status = params.request?.filterModel?.status?.values
                    that.search.siteName = params.request?.filterModel?.siteName?.filter
                    that.search.gln = params.request?.filterModel?.gln?.filter
                    that.search.userCount = params.request?.filterModel?.userCount?.filter
                    that.search.add1 = params.request?.filterModel?.siteAddress?.filter
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    sitesService.findSites({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search,
                        organization_id: that.organization_id,
                        search: that.globalSearchValue
                    }).then(resp => {
                        if (!resp.error) {
                            const sitesArray = resp.data.d.c.map(item => {
                                // Add computed field for address display
                                item.siteAddress = item.add1 || ''
                                return item
                            })
                            that.items = sitesArray
                            that.total = resp.data.d.t
                            if (that.total == 0) {
                                that.gridApi.showNoRowsOverlay()
                            } else {
                                that.gridApi.hideOverlay()
                            }
                            params.successCallback(sitesArray)
                        }
                    }).catch(error => {
                        console.error(error)
                        params.failCallback()
                    })
                }
            }
            // Register datasource with the grid
            params.api.setServerSideDatasource(datasource)
        },
        onCellClicked(params) {
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'edit') {
                    this.updateSite({ site_id: params.event.target.dataset.siteId })
                }
                if (params.event.target.dataset.action === 'view') {
                    this.view({ site_id: params.event.target.dataset.siteId, siteName: params.event.target.dataset.siteName })
                }
                if (params.event.target.dataset.action === 'deactivate') {
                    this.activeDeactive(params.data, { target: { innerText: 'Deactivate' } })
                }
                if (params.event.target.dataset.action === 'activate') {
                    this.activeDeactive(params.data, { target: { innerText: 'Activate' } })
                }
                return
            }
            // Call view when clicking on any other cell
            this.view(params.data)
        },
        onGlobalSearchChange(searchValue) {
            this.globalSearchValue = searchValue
            this.debounceInput(searchValue)
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length > 2) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        fetchOrgMeta() {
            orgServices.findMeta().then(resp => {
                if (!resp.error) {
                    this.organizations = resp.data.d
                }
            })
        },
        ConfirmDeactivateSites(item, e) {
            sitesService.DeactiveSiteByReAssignSiteId(item.site_id, e.target.innerText).then(resp => {
                if (!resp.error) {
                    if (this.gridApi) {
                        this.gridApi.refreshServerSideStore()
                    }
                    if (resp.data.d == 'INACTIVE') {
                        this._showToast('The site has been deactivated.')
                    }
                }
            })
        },
        activeDeactiveSite(item, e) {
            sitesService.activeDeactiveSite(item.site_id, e.target.innerText).then(resp => {
                if (!resp.error) {
                    if (this.gridApi) {
                        this.gridApi.refreshServerSideStore()
                    }
                    if (resp.data.d == 'INACTIVE') {
                        this._showToast('The site has been deactivated.')
                    }
                    else {
                        this._showToast('The site has been activated.')
                    }
                }
            })
        },
        activeDeactive(item, e) {
            if(e.target.innerText=='Deactivate')
            {
                if(item.userCount>0)
                {
                    this._showConfirm('This site currently has users assigned to it. If you continue with the deactivation process, all users assigned to this site will be reassigned to the Corporate site. If you would like to assign different sites to those users, click Cancel and assign a different site to each user.').then(confirm => {
                        if (confirm) {
                            if(item.locationSiteCount>0)
                            {
                                this._showConfirm('This site currently has locations assigned to it. If you continue with the deactivation process, all locations assigned to this site will be reassigned to the Corporate site. If you would like to assign different sites to those locations, click Cancel and assign a different site to each location.').then(confirm => {
                                    if (confirm) {
                                        this.ConfirmDeactivateSites(item,e)
                                    }
                                })
                            }
                            else{
                                this.ConfirmDeactivateSites(item,e)
                            }
                        }
                    })
                }
                if(item.userCount==0 && item.locationSiteCount>0)
                {
                    this._showConfirm('This site currently has locations assigned to it. If you continue with the deactivation process, all locations assigned to this site will be reassigned to the Corporate site. If you would like to assign different sites to those locations, click Cancel and assign a different site to each location.').then(confirm => {
                        if (confirm) {
                            this.ConfirmDeactivateSites(item,e)
                        }
                    })
                }
                if(item.userCount==0 && item.locationSiteCount==0)
                {
                    this.activeDeactiveSite(item,e)
                }
            }
            else{
                this.activeDeactiveSite(item,e)
            }

            if (e) {
                e.stopPropagation()
            }
        },
    }
}